/// <reference path="../../typings/index.d.ts" />
/// <reference path="plugins/controlgallery/controlgallery.module.ts" />
/// <reference path="components/controls/controls.module.ts" />
/// <reference path="plugins/stylegallery/styleGallery.module.ts" />
/// <reference path="components/filters/filters.module.ts" />
/// <reference path="components/logging/logging.module.ts" />
/// <reference path="components/interceptors/interceptors.module.ts" />
/// <reference path="plugins/client/client.module.ts" />
/// <reference path="plugins/clientclienttype/clientclienttype.module.ts" />
/// <reference path="plugins/employee/employee.module.ts" />
/// <reference path="components/modal/modal.module.ts" />
/// <reference path="components/common/common.module.ts" />
/// <reference path="plugins/login/login.module.ts" />
/// <reference path="plugins/AppointmentBook/js/module.ts"/>
/// <reference path="plugins/smartcenter/smartcenter.module.ts" />
/// <reference path="plugins/callCenter/callCenter.module.ts" />
/// <reference path="plugins/cancellationreasons/cancellationreasons.module.ts" />
/// <reference path="plugins/services/services.module.ts" />
/// <reference path="plugins/referraltypes/referraltypes.module.ts" />
/// <reference path="plugins/blocktypes/blocktypes.module.ts" />
/// <reference path="plugins/reports/reports.module.ts" />
/// <reference path="plugins/reportScheduler/reportScheduler.module.ts" />
/// <reference path="plugins/reportingHierarchy/reportingHierarchy.module.ts" />
/// <reference path="plugins/giftcardtypes/giftcardtypes.module.ts" />
/// <reference path="plugins/visitnotetypes/visitnotetypes.module.ts" />
/// <reference path="plugins/businessinfo/businessinfo.module.ts" />
/// <reference path="plugins/businesstypes/businesstypes.module.ts" />
/// <reference path="plugins/locationgroups/locationgroups.module.ts" />
/// <reference path="plugins/standingAppointments/standingAppointments.module.ts" />
/// <reference path="plugins/confirmationmanager/confirmationmanager.module.ts" />
/// <reference path="components/search/search.module.ts" />
/// <reference path="plugins/serviceCategories/serviceCategories.module.ts" />
/// <reference path="plugins/employeeTemplates/employeeTemplates.module.ts" />
/// <reference path="plugins/register/register.module.ts" />
/// <reference path="plugins/securityRoles/securityRoles.module.ts" />
/// <reference path="plugins/securityRolesManager/securityRolesManager.module.ts" />
/// <reference path="plugins/employeeCategories/employeeCategories.module.ts" />
/// <reference path="plugins/resources/resources.module.ts" />
/// <reference path="plugins/appointmentCategories/appointmentCategories.module.ts" />
/// <reference path="components/tracking/tracking.module.ts" />
/// <reference path="components/locationpicker/locationpicker.module.ts" />
/// <reference path="components/scrollableLocationSelector/scrollableLocationSelector.module.ts" />
/// <reference path="plugins/onlineBookingSettings/onlineBookingSettings.module.ts" />
/// <reference path="plugins/drawer/drawer.module.ts" />
/// <reference path="plugins/drawerManager/drawerManager.module.ts" />
/// <reference path="plugins/CallCenter/callCenter.module.ts" />
/// <reference path="components/fileupload/fileupload.module.ts" />
/// <reference path="components/imageFileUpload/imageFileUpload.module.ts" />
/// <reference path="components/compensation/compensation.module.ts" />
/// <reference path="components/mover/mover.module.ts" />
/// <reference path="components/hostedPage/hostedPage.module.ts" />
/// <reference path="plugins/notificationTemplates/notificationTemplates.module.ts" />
/// <reference path="plugins/resourceCategories/resourceCategories.module.ts" />
/// <reference path="plugins/waitList/waitList.module.ts" />
/// <reference path="plugins/clientMerge/clientMerge.module.ts" />
/// <reference path="plugins/clientManualMerge/clientManualMerge.module.ts" />
/// <reference path="plugins/sandbox/sandbox.module.ts" />
/// <reference path="plugins/standingBlocks/standingBlocks.module.ts" />
/// <reference path="plugins/product/product.module.ts" />
/// <reference path="plugins/productBulkUpdate/productBulkUpdate.module.ts" />
/// <reference path="plugins/stockLevels/stockLevels.module.ts" />
/// <reference path="plugins/walkinManagerSettings/walkinManagerSettings.module.ts" />
/// <reference path="plugins/walkinManager/walkinManager.module.ts" />
/// <reference path="plugins/employeeTemplatePromotions/employeeTemplatePromotions.module.ts" />
/// <reference path="plugins/productCategories/productCategories.module.ts" />
/// <reference path="plugins/distributors/distributors.module.ts" />
/// <reference path="plugins/manufacturers/manufacturers.module.ts" />
/// <reference path="plugins/distributors/distributors.module.ts" />
/// <reference path="plugins/walkinManagerKiosk/walkinManagerKiosk.module.ts" />
/// <reference path="plugins/walkinManagerDisplay/walkinManagerDisplay.module.ts" />
/// <reference path="plugins/workactivities/workactivities.module.ts" />
/// <reference path="plugins/userDefinedControls/userDefinedControls.module.ts" />
/// <reference path="plugins/paymentType/paymentType.module.ts" />
/// <reference path="plugins/posHardware/posHardware.module.ts" />
/// <reference path="plugins/packageTypes/packageTypes.module.ts" />
/// <reference path="plugins/memberships/memberships.module.ts" />
/// <reference path="plugins/membershipTypes/membershipTypes.module.ts" />
/// <reference path="plugins/membershipDefinitions/membershipDefinitions.module.ts" />
/// <reference path="plugins/memberBenefitTemplates/memberBenefitTemplates.module.ts" />
/// <reference path="plugins/membershipManager/membershipManager.module.ts" />
/// <reference path="plugins/membershipCancellation/membershipCancellation.module.ts" />
/// <reference path="plugins/equipment/equipment.module.ts" />
/// <reference path="plugins/discounts/discounts.module.ts" />
/// <reference path="plugins/floorlocation/floorlocation.module.ts" />
/// <reference path="plugins/payinoutreasons/payinoutreasons.module.ts" />
/// <reference path="plugins/swapGroups/swapGroups.module.ts" />
/// <reference path="plugins/inventoryCount/inventoryCount.module.ts" />
/// <reference path="plugins/merchantAccounts/merchantAccounts.module.ts" />
/// <reference path="plugins/integrations/integrations.module.ts" />
/// <reference path="plugins/addOnGroup/addOnGroup.module.ts" />
/// <reference path="plugins/productBundles/productBundles.module.ts" />
/// <reference path="plugins/ipRestrictions/ipRestrictions.module.ts"/>
/// <reference path="plugins/marketPricing/marketPricing.module.ts"/>
/// <reference path="plugins/transactionEditor/transactionEditor.module.ts"/>
/// <reference path="plugins/profileSettings/profileSettings.module.ts" />
/// <reference path="plugins/holiday/holiday.module.ts"/>
/// <reference path="plugins/meevoTheming/meevoTheming.module.ts"/>
/// <reference path="plugins/eventschedule/eventSchedule.module.ts" />
/// <reference path="plugins/timeClock/timeClock.module.ts" />
/// <reference path="plugins/notificationSetting/notificationSetting.module.ts" />
/// <reference path="plugins/purchaseOrder/purchaseOrder.module.ts" />
/// <reference path="plugins/customBranding/customBranding.module.ts" />
/// <reference path="plugins/clientPoint/clientPoint.module.ts" />
/// <reference path="plugins/compensationSettings/compensationSettings.module.ts" />
/// <reference path="plugins/cultureSettings/cultureSettings.module.ts" />
/// <reference path="plugins/emmaAccountSettings/emmaAccountSettings.module.ts" />

/// <reference path="plugins/employeeSupplyUsage/employeeSupplyUsage.module.ts" />
/// <reference path="plugins/tax/tax.module.ts" />
/// <reference path="plugins/giftCardBalance/giftCardBalance.module.ts" />
/// <reference path="plugins/giftCardIntegration/giftCardIntegration.module.ts" />
/// <reference path="plugins/miscSupplyDefinitions/miscSupplyDefinitions.module.ts" />
/// <reference path="plugins/imagegallerycategory/imageGalleryCategory.module.ts" />
/// <reference path="plugins/inventoryReturns/inventoryReturns.module.ts" />
/// <reference path="plugins/activityLog/activityLog.module.ts" />
/// <reference path="plugins/alertsManager/alertsManager.module.ts" />
/// <reference path="plugins/alertsLog/alertsLog.module.ts" />
/// <reference path="plugins/eftControlPanel/eftControlPanel.module.ts" />
/// <reference path="plugins/packageLookup/packageLookup.module.ts" />
/// <reference path="plugins/saleProgram/saleProgram.module.ts" />
/// <reference path="plugins/location/location.module.ts" />
/// <reference path="plugins/payroll/payroll.module.ts" />
/// <reference path="plugins/basicEmailMarketing/basicEmailMarketing.module.ts" />
/// <reference path="plugins/departments/departments.module.ts" />
/// <reference path="plugins/departmentGoal/departmentGoal.module.ts" />
/// <reference path="plugins/employeeGoal/employeeGoal.module.ts" />
/// <reference path="plugins/dashboardGoals/dashboardGoals.module.ts" />
/// <reference path="plugins/accountsync/accountsync.module.ts" />
/// <reference path="plugins/quickbooksDesktop/quickbooksDesktop.module.ts" />
/// <reference path="plugins/egifts/egifts.module.ts" />
/// <reference path="plugins/shippingFees/shippingFees.module.ts" />
/// <reference path="plugins/meevoStore/meevoStore.module.ts" />
/// <reference path="plugins/pointPromotionCampaign/pointPromotionCampaign.module.ts" />
/// <reference path="plugins/fieldLabels/fieldLabels.module.ts" />
/// <reference path="plugins/docsAndForms/docs-and-forms.module.ts" />
/// <reference path="plugins/transworld/transworld.module.ts" />
/// <reference path="plugins/paging/paging.module.ts" />
/// <reference path="plugins/salesRankings/salesRankings.module.ts" />
/// <reference path="plugins/ratingsControlPanel/ratings-control-panel.module.ts" />
/// <reference path="plugins/techSphere/techSphere.module.ts" />
/// <reference path="plugins/serviceswizard/serviceswizard.module.ts" />
/// <reference path="plugins/student/student.module.ts" />
/// <reference path="plugins/teachers/teachers.module.ts" />
/// <reference path="plugins/textelBlast/textelBlast.module.ts" />
/// <reference path="plugins/meevoMessenger/meevoMessenger.module.ts" />
/// <reference path="plugins/meevoMessengerSettings/meevoMessengerSettings.module.ts" />
/// <reference path="components/short-cuts/short-cuts.module.ts" />
/// <reference path="plugins/clientIntake/clientIntake.module.ts" />
/// <reference path="plugins/clientIntakeForm/clientIntakeForm.module.ts" />
/// <reference path="plugins/selfCheckInKiosk/selfCheckInKiosk.module.ts" />
/// <reference path="plugins/selfCheckInKioskSettings/selfCheckInKioskSettings.module.ts" />
/// <reference path="plugins/aveda/aveda.module.ts" />
/// <reference path="plugins/employeeServiceTimesPricing/employeeServiceTimesPricing.module.ts" />
/// <reference path="plugins/fiveStarRatingSetting/fiveStarRatingSettings.module.ts" />
/// <reference path="plugins/servicecharges/servicecharges.module.ts" />
/// <reference path="plugins/fameAdvantage/fame-advantage.module.ts" />
/// <reference path="plugins/note/note.module.ts" />
/// <reference path="plugins/royaltyExport/royaltyExport.module.ts" />
/// <reference path="plugins/referral/referral.module.ts" />
/// <reference path="plugins/meevoBi/meevoBi.module.ts" />
/// <reference path="plugins/yext/onlinePresenceManagement/onlinePresenceManagement.module.ts" />
/// <reference path="plugins/onlinePresenceSettings/onlinePresenceSettings.module.ts" />
/// <reference path="plugins/systemToolbox/systemToolbox.module.ts" />
/// <reference path="plugins/yieldManagementStrategy/yield-management-strategy.module.ts" />
/// <reference path="plugins/yieldManagementProgram/yield-management-program.module.ts" />
/// <reference path="plugins/inventoryTransfer/inventoryTransfer.module.ts"/>
/// <reference path="plugins/interop/interop.module.ts" />
/// <reference path="plugins/systemVersions/systemVersions.module.ts" />
/// <reference path="plugins/clientApp/clientApp.module.ts" />
/// <reference path="plugins/usageReasons/usageReasons.module.ts" />
/// <reference path="plugins/paymentPlans/paymentPlans.module.ts" />
/// <reference path="plugins/tippy/tippy.module.ts" />
/// <reference path="plugins/docsAndFormsKiosk/docs-and-forms-kiosk.module.ts" />
/// <reference path="components/udf-image-upload-component/udf-image-upload.module.ts" />
/// <reference path="plugins/merchantAccountsOnboardingTesting/merchantAccountsOnboardingTesting.module.ts" />
/// <reference path="plugins/charts/charts.module.ts" />
/// <reference path="plugins/chartPhrases/chartPhrases.module.ts" />
/// <reference path="plugins/upsellOpportunities/upsellOpportunities.module.ts" />
/// <reference path="plugins/AIReceptionist/js/aiReceptionist.module.ts" />
/// <reference path="plugins/meevoPaySummary/js/meevoPaySummary.module.ts" />
/// <reference path="components/globalNav/globalNav.module.ts" />
/// <reference path="components/globalNav/globalNav.directive.ts" />
/// <reference path="components/globalNav/globalNavTopRow.directive.ts" />
/// <reference path="components/globalNav/globalNavCommandRow.directive.ts" />

module Meevo {
    'use strict';

    angular.module('meevo',
        [
            'meevo.core',
            'meevo.components.common',
            'meevo.components.controls',
            'meevo.components.filters',
            'meevo.components.logging',
            'meevo.components.modal',
            'meevo.components.search',
            'meevo.components.aichat',
            'meevo.components.locationPicker',
            'meevo.components.scrollableLocationSelector',
            'meevo.components.interceptors',
            'meevo.components.fileupload',
            'meevo.components.imageFileUpload',
            'meevo.components.tracking',
            'meevo.components.compensation',
            'meevo.components.mover',
            'meevo.components.hostedPage',
            'meevo.plugins.controlgallery',
            'meevo.plugins.client',
            'meevo.plugins.clientClientType',
            'meevo.plugins.employee',
            'meevo.plugins.styleGallery',
            'meevo.plugins.login',
            'ApptBookApp',
            'meevo.plugins.smartCenter',
            'meevo.plugins.callCenter',
            'meevo.plugins.cancellationReasons',
            'meevo.plugins.services',
            'meevo.plugins.giftCardTypes',
            'meevo.plugins.referralTypes',
            'meevo.plugins.blockTypes',
            'meevo.plugins.visitNoteTypes',
            'meevo.plugins.reports',
            'meevo.plugins.performanceInsights',
            'meevo.plugins.insightsUserManagement',
            'meevo.plugins.reportScheduler',
            'meevo.plugins.reportingHierarchy',
            'meevo.plugins.businessInfo',
            'meevo.plugins.businessTypes',
            'meevo.plugins.locationGroups',
            'meevo.plugins.standingAppointments',
            'meevo.plugins.standingBlocks',
            'meevo.plugins.confirmationManager',
            'meevo.plugins.serviceCategories',
            'meevo.plugins.employeeTemplates',
            'meevo.plugins.register',
            'meevo.plugins.securityRoles',
            'meevo.plugins.securityRolesManager',
            'angular-carousel',
            'meevo.plugins.employeeCategories',
            'meevo.plugins.resources',
            'meevo.plugins.appointmentCategories',
            'meevo.plugins.waitList',
            'meevo.plugins.clientMerge',
            'meevo.plugins.clientManualMerge',
            'meevo.plugins.sandbox',
            'meevo.plugins.notificationTemplates',
            'meevo.plugins.resourceCategories',
            'meevo.plugins.workActivities',
            'meevo.plugins.product',
            'meevo.plugins.productBulkUpdate',
            'meevo.plugins.productBundles',
            'meevo.plugins.equipment',
            'meevo.plugins.floorLocation',
            'meevo.plugins.stockLevels',
            'meevo.plugins.modelQuantityAnalysis',
            'meevo.plugins.inventoryTurnsAnalysis',
            'meevo.plugins.slowMovingInventoryAnalysis',
            'meevo.plugins.walkinManagerSettings',
            'ngWYSIWYG',
            'meevo.plugins.walkinManager',
            'meevo.plugins.employeeTemplatePromotions',
            'meevo.plugins.productCategories',
            'meevo.plugins.distributors',
            'vAccordion',
            'meevo.plugins.manufacturers',
            'meevo.plugins.discounts',
            'meevo.plugins.drawer',
            'meevo.plugins.walkinManagerKiosk',
            'meevo.plugins.walkinManagerDisplay',
            'meevo.plugins.onlineBookingSettings',
            'meevo.plugins.payinoutreasons',
            'meevo.plugins.userDefinedControls',
            'meevo.plugins.paymentType',
            'meevo.plugins.posHardware',
            'meevo.plugins.drawerManager',
            'meevo.plugins.packageTypes',
            'meevo.plugins.purchaseOrder',
            'meevo.plugins.memberships',
            'meevo.plugins.membershipTypes',
            'meevo.plugins.membershipDefinitions',
            'meevo.plugins.memberBenefitTemplates',
            'meevo.plugins.membershipManager',
            'meevo.plugins.membershipCancellation',
            'meevo.plugins.swapGroups',
            'meevo.plugins.ipRestrictions',
            'meevo.plugins.marketPricing',
            'meevo.plugins.inventoryCount',
            'meevo.plugins.merchantAccounts',
            'meevo.plugins.transactionEditor',
            'meevo.plugins.profileSettings',
            'meevo.plugins.holiday',
            'meevo.plugins.meevoTheming',
            'meevo.plugins.notificationSetting',
            'meevo.plugins.integrations',
            'meevo.plugins.addOnGroup',
            'meevo.plugins.eventSchedule',
            'meevo.plugins.timeClock',
            'meevo.plugins.customBranding',
            'ui.tree',
            'meevo.plugins.clientPoint',
            'meevo.plugins.compensationSettings',
            'meevo.plugins.cultureSettings',
            'meevo.plugins.employeeSupplyUsage',
            'meevo.plugins.tax',
            'meevo.plugins.giftCardBalance',
            'meevo.plugins.giftCardIntegration',
            'meevo.plugins.tax',
            'meevo.plugins.miscSupplyDefinitions',
            'meevo.plugins.inventoryReturns',
            'meevo.plugins.activityLog',
            'meevo.plugins.alertsManager',
            'meevo.plugins.alertsLog',
            'meevo.plugins.imageGalleryCategory',
            'meevo.plugins.packageLookup',
            'meevo.plugins.saleProgram',
            'meevo.plugins.eftControlPanel',
            'meevo.plugins.location',
            'meevo.plugins.payroll',
            'meevo.plugins.basicEmailMarketing',
            'meevo.plugins.departments',
            'meevo.plugins.departmentGoal',
            'meevo.plugins.employeeGoal',
            'meevo.plugins.accountsync',
            'meevo.plugins.quickbooksDesktop',
            'meevo.plugins.egifts',
            'meevo.plugins.shippingFees',
            'meevo.plugins.paging',
            'meevo.plugins.meevoStore',
            'meevo.plugins.fieldLabels',
            'meevo.plugins.docsAndForms',
            'meevo.plugins.dashboardGoals',
            'meevo.plugins.transworld',
            "meevo.plugins.emmaAccountSettings",
            'meevo.plugins.salesRankings',
            'tmh.dynamicLocale',
            'ngIntlTelInput',
            'meevo.plugins.pointPromotionCampaign',
            'meevo.plugins.ratingsControlPanel',
            'meevo.plugins.techSphere',
            'meevo.plugins.servicesWizard',
            'meevo.plugins.meevoMessenger',
            'meevo.plugins.meevoMessengerSettings',
            'meevo.plugins.textelBlast',
            'meevo.plugins.student',
            'meevo.plugins.teachers',
            'meevo.components.short-cuts',
            'meevo.plugins.clientIntake',
            'meevo.plugins.clientIntakeForm',
            'meevo.plugins.selfCheckInKiosk',
            'meevo.plugins.selfCheckInKioskSettings',
            'meevo.plugins.aveda',
            'meevo.plugins.employeeServiceTimesPricing',
            'meevo.plugins.fiveStarRatingSettings',
            'meevo.plugins.serviceCharges',
            'meevo.plugins.fameAdvantage',
            'meevo.plugins.adpIntegration',
            'meevo.plugins.note',
            'meevo.plugins.royaltyExport',
            'meevo.plugins.interop',
            'meevo.plugins.referral',
            'meevo.plugins.meevoBi',
            'meevo.plugins.yieldManagementStrategy',
            'meevo.plugins.yieldManagementProgram',
            'meevo.plugins.onlinePresenceManagement',
            'meevo.plugins.onlinePresenceSettings',
            'meevo.plugins.clientApp',
            'meevo.plugins.systemToolbox',
            'meevo.plugins.inventoryTransfer',
            'meevo.plugins.systemVersions',
            'meevo.plugins.usageReasons',
            'meevo.plugins.paymentPlans',
            'meevo.plugins.tippy',
            'meevo.plugins.docsAndFormsKiosk',
            'meevo.components.udfImageUpload',
            'meevo.plugins.merchantAccountsOnboardingTesting',
            'meevo.plugins.charts',
            'meevo.plugins.chartPhrases',
            'meevo.plugins.upsellOpportunities',
            'meevo.plugins.aiReceptionist',
            'meevo.plugins.meevoPaySummary',
            'meevo.components.globalNav',
        ]);
}
